// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"4c9ecac9","977":"ea8ebcef"}[chunkId] + ".chunk.js";
};